import { useUser } from "@saleor/auth";
import DialogInfo from "@saleor/components/DialogInfo";
import { useGetCustomerBlockLazyQuery } from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import React, { createContext, useEffect, useState } from "react";

export const CustomerBlockContext = createContext(null);

const CustomerBlockContextProvider = props => {
  const navigate = useNavigator();
  const { company } = useUser();
  const [customerBlockDialog, setCustomerBlockDialog] = useState(false);
  const [creditBlockDialog, setCreditBlockDialog] = useState(false);
  const [customerBlockStatus, setCustomerBlockStatus] = useState<
    boolean | null
  >(false);

  const [
    getCustomerBlockLazy,
    { data: customerBlockData }
  ] = useGetCustomerBlockLazyQuery();

  const onCloseCustomerBlockDialog = () => {
    setCustomerBlockDialog(false);
    navigate("/");
  };

  const onCloseCreditBlockDialog = () => {
    setCreditBlockDialog(false);
    navigate("/");
  };

  const onOpenCustomerBlockDialog = () => setCustomerBlockDialog(true);
  const onOpenCreditBlockDialog = () => setCreditBlockDialog(true);

  const renderCustomerBlockDialog = () => {
    if (customerBlockStatus) {
      return (
        <DialogInfo
          isOpen={customerBlockDialog}
          onClose={onCloseCustomerBlockDialog}
          contentText="ไม่สามารถทำรายการได้ กรุณาติดต่อผู้ดูแลระบบ"
          buttonText="ปิด"
        />
      );
    }
  };

  const renderCreditBlockDialog = () => (
    <DialogInfo
      isOpen={creditBlockDialog}
      onClose={onCloseCreditBlockDialog}
      contentText={
        "ไม่สามารถดำเนินการต่อได้ เนื่องจาก credit block \nกรุณาติดต่อผู้แทนขายของท่าน"
      }
      buttonText="ปิด"
    />
  );

  const fetchCustomerBlock = () => {
    getCustomerBlockLazy({
      variables: {
        input: {
          soldToCode: company
        }
      }
    });
  };

  useEffect(() => {
    fetchCustomerBlock();
  }, [company]);

  useEffect(() => {
    if (customerBlockData) {
      setCustomerBlockStatus(
        customerBlockData?.getCustomerBlock?.customerBlock
      );
    }
  }, [customerBlockData]);

  return (
    <CustomerBlockContext.Provider
      value={{
        customerBlockStatus,
        onOpenCustomerBlockDialog,
        onOpenCreditBlockDialog
      }}
    >
      {props.children}
      {renderCustomerBlockDialog()}
      {renderCreditBlockDialog()}
    </CustomerBlockContext.Provider>
  );
};

export default CustomerBlockContextProvider;
